import { createContext, useContext, useEffect, useState } from "react";
import api from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", { ...payload });
    if (data && data.email_verification_required) return data;
    setUser(data);
    return data;
  };
  const verifyEmail = async (token) => {
    const { data } = await api.post("/auth/verify", { token });
    setUser(data);
    return data;
  };
  const resendVerification = async (email) => {
    await api.post("/auth/resend-verification", { email });
  };
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // Auch bei einem Fehler lokal abmelden, damit die Oberfläche nie hängen bleibt.
    } finally {
      setUser(false);
    }
  };

  const updateLang = async (lang) => {
    const { data } = await api.put("/auth/me/lang", { lang });
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, verifyEmail, resendVerification, logout, updateLang }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);